/** JCAT-6294 / JCAT-6293: 体験タグからハブページ（エリア・全国テーマ）へのリンクを組み立てる。 */
import { displayDestinationTagName, type WabunkaExperienceTagListViewModel } from '@/wabunka-src/features/Experience/models/wabunkaExperienceTag';

export interface HubLink {
  name: string;
  path: string;
}

/** JCAT-6294: 最初の destination タグからエリアハブのパスを返す。 */
export const buildDestinationHubPath = (tags: WabunkaExperienceTagListViewModel): string | undefined => {
  const webPath = tags.find((tag) => tag.tag.tagGroupType === 'destination')?.tag.webPath;
  return webPath ? `/${webPath}/` : undefined;
};

/** エリアハブへのリンクを返し、名前は displayDestinationTagName で整形する。 */
export const buildDestinationHubLink = (tags: WabunkaExperienceTagListViewModel): HubLink | undefined => {
  const path = buildDestinationHubPath(tags);
  const name = displayDestinationTagName(tags);
  return path && name ? { name, path } : undefined;
};

/**
 * 体験詳細のテーマ導線用に、全国テーマハブ /japan/{theme}/ へのリンクを返す。
 * 全テーマへの導線を残すため、件数上限・タググループ名による除外を持たない（D-020）。
 * 体験カードの extractDisplayThemeTags の3件上限や除外条件には揃えない。
 * 並べ替えず、API の順（体験タグの sequence_id 昇順）のまま返す。
 */
export const buildThemeHubLinks = (tags: WabunkaExperienceTagListViewModel): HubLink[] => {
  const links: HubLink[] = [];
  const seenIds = new Set<string>();
  for (const { tag } of tags) {
    if (tag.tagGroupType !== 'theme' || seenIds.has(tag.id)) continue;
    seenIds.add(tag.id);
    if (!tag.webPath || !tag.name.trim()) continue;
    links.push({ name: tag.name, path: `/japan/${tag.webPath}/` });
  }
  return links;
};
